import { DATE_PIPE_DEFAULT_OPTIONS, DatePipeConfig } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import {
  InjectionToken,
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { SIGVCoreApiModule } from '../common-api/public-api';
import {
  AppContext,
  EnvConfig,
  Logger,
  SIGVCommonModule,
} from '../common/public-api';
import { CoreFeatureFlagModule } from '../rt-shared/services/core-feature-flag.module';
import { SIGVErrorModule } from '../rt-shared/services/error/error.module';
import { AuthGuard } from './guards/auth.guard';
import { AppEnvService } from './services/app-env.service';

export const ENV_CONFIG_URI = 'assets/env/env.json';

export function loadEnvConfig(uri: string = ENV_CONFIG_URI): Promise<any> {
  return fetch(uri).then((resp) => resp.json());
}

const ENV_CONFIG = new InjectionToken<EnvConfig>('ENV_CONFIG');

function datePipeDefaultOptionsFactory(
  appContext: AppContext,
  appEnv: AppEnvService
): DatePipeConfig {
  const dateFormat = appContext.envConfig?.format.datetime as string;
  const timezone = appEnv.timezoneInfo?.offsetName as string;
  const datePipeConfig: DatePipeConfig = {
    dateFormat,
    timezone,
  };
  console.log('DATE_PIPE_DEFAULT_OPTIONS created');
  console.log(datePipeConfig);
  return datePipeConfig;
}

function appContextFactory(envConfig: EnvConfig): AppContext {
  const appContext = new AppContext();
  appContext.envConfig = envConfig;

  return appContext;
}

@NgModule({
  declarations: [],
  imports: [
    RouterModule,
    HttpClientModule,
    SIGVCommonModule,
    SIGVCoreApiModule,
    SIGVErrorModule,
    CoreFeatureFlagModule,
  ],
  exports: [SIGVCommonModule, SIGVCoreApiModule, SIGVErrorModule],
  providers: [Logger, AuthGuard],
})
export class SIGVCoreModule {
  constructor(@Optional() @SkipSelf() parentModule: SIGVCoreModule) {
    if (parentModule) {
      throw new Error(
        `${
          new.target.name
        } is already loaded. Import in your base AppModule only.`
      );
    }
  }

  static forRoot(config: EnvConfig): ModuleWithProviders<SIGVCoreModule> {
    return {
      ngModule: SIGVCoreModule,
      providers: [
        {
          provide: ENV_CONFIG,
          useValue: config,
        },
        {
          provide: AppContext,
          useFactory: appContextFactory,
          deps: [ENV_CONFIG],
        },
        AppEnvService,
        {
          provide: DATE_PIPE_DEFAULT_OPTIONS,
          useFactory: datePipeDefaultOptionsFactory,
          deps: [AppContext, AppEnvService],
        },
        ...(SIGVCoreApiModule.forRoot(config.apiUrls).providers ?? []),
        ...(SIGVErrorModule.forRoot(config.apimFilters).providers ?? []),
        ...(CoreFeatureFlagModule.forRoot(config).providers ?? []),
      ],
    };
  }
}
